__turbopack_context__.v({
  "br": "CouponBanner-module-scss-module__1OtzsW__br",
  "close_button_desktop": "CouponBanner-module-scss-module__1OtzsW__close_button_desktop",
  "close_button_mobile": "CouponBanner-module-scss-module__1OtzsW__close_button_mobile",
  "coupon_banner": "CouponBanner-module-scss-module__1OtzsW__coupon_banner",
  "coupon_banner_button": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_button",
  "coupon_banner_button_arrow": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_button_arrow",
  "coupon_banner_button_wrapper": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_button_wrapper",
  "coupon_banner_close": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_close",
  "coupon_banner_content": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_content",
  "coupon_banner_content_title": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_content_title",
  "coupon_banner_wrapper": "CouponBanner-module-scss-module__1OtzsW__coupon_banner_wrapper",
  "highlight_text": "CouponBanner-module-scss-module__1OtzsW__highlight_text",
  "wrap": "CouponBanner-module-scss-module__1OtzsW__wrap",
});
